import { Component, OnInit } from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Inject} from "@angular/core";

/**
 * Parameters for AddThresholdConfirmDialogComponent
 */
export interface AddThresholdConfirmDialogData {
  transitTime: string;
  threshold: string;
  cronDescriptor: string;
  componentKeyValue: string;
}

@Component({
  selector: 'app-add-threshold-confirm-dialog',
  templateUrl: './add-threshold-confirm-dialog.component.html',
  styleUrls: ['./add-threshold-confirm-dialog.component.scss'],
  animations: [
    trigger('dialog', [
      transition('void => *', [
        style({transform: 'scale3d(.3, .3, .3)'}),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({transform: 'scale3d(.0, .0, .0)'}))
      ])
    ])
  ]
})
export class AddThresholdConfirmDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddThresholdConfirmDialogData
  ) { }

  ngOnInit(): void {
  }
}
